import { useRouter } from 'next/router';

export const useLmsDestination = (): string | null => {
    const router = useRouter();

    const param: string | string[] | undefined = router.query.til;
    const destinations: string[] = param ? (Array.isArray(param) ? param : [param]) : [];

    if (destinations.length === 0) {
        return null;
    }

    const lastDestination = destinations[destinations.length - 1].split(';');
    const lastDestinationLocation = lastDestination.length > 2 ? lastDestination[lastDestination.length - 1] : undefined;

    return lastDestination[1] + (lastDestinationLocation ? `, ${lastDestinationLocation}` : '');
};
